import BOM from './BOM';
import Checklists from './Checklists';
import Emailer from './Emailer';
import Forms from './Forms';
import InitialSetup from './InitialSetup';
import Lookups from './Lookups';
import Options from './Options';
import Organizations from './Organizations';
import Permissions from './Permissions';
import Processes from './Processes';
import ProductTypes from './ProductTypes';
import Projects from './Projects';
import PurchaseOrders from './PurchaseOrders';
import Quotations from './Quotations';
import Requirements from './Requirements';
import RFQ from './RFQ';
import RFQTypes from './RFQTypes';
import Search from './Search';
import Statuses from './Statuses';
import Users from './Users';
import UserRoles from './UserRoles';
import Vault from './Vault';

var SDK = {
    BOM: BOM,
    Checklists:Checklists,
    Emailer: Emailer,
    Forms:Forms,
    InitialSetup: InitialSetup,
    Lookups: Lookups,
    Options: Options,
    Organizations: Organizations,
    Permissions: Permissions,
    Processes: Processes,
    ProductTypes: ProductTypes,
    Projects: Projects,
    PurchaseOrders: PurchaseOrders,
    Quotations:Quotations,
    Requirements: Requirements,
    RFQ:RFQ,
    RFQTypes:RFQTypes,
    Search:Search,
    Statuses:Statuses,
    Users: Users,
    UserRoles: UserRoles,
    Vault: Vault
}

export {
    BOM,
    Checklists,
    Emailer,
    Forms,
    InitialSetup,
    Options,
    Organizations,
    Permissions,
    Processes,
    ProductTypes,
    Projects,
    PurchaseOrders,
    Quotations,
    Requirements,
    RFQ,
    RFQTypes,
    Users,
    UserRoles,
    Vault
};

export default SDK;